"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FilterPharmacyForm = function FilterPharmacyForm(_ref) {
  var form = _ref.form,
    zip = _ref.zip,
    onSubmit = _ref.onSubmit;
  var getFieldDecorator = form.getFieldDecorator;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    form.validateFieldsAndScroll(function (err, values) {
      if (!err) {
        var data = (0, _lodash.pickBy)(values, function (value) {
          return value;
        });
        if ((0, _lodash.isEmpty)(data)) {
          _utils.toast.error({
            title: 'Please provide at least one filter parameter'
          });
          return;
        }
        onSubmit(data);
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_form.default, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label material-form-item"
  }, getFieldDecorator('name', {
    rules: [{
      min: 3,
      message: 'Pharmacy Name must contain at least 3 characters'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Pharmacy Name",
    type: "text",
    name: "name"
  })))), /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label material-form-item"
  }, getFieldDecorator('city', {
    rules: [{
      min: 2,
      message: 'City must contain at least 2 characters'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "City",
    type: "text",
    name: "city"
  }))))), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label material-form-item"
  }, getFieldDecorator('zip', {
    initialValue: zip,
    rules: [{
      min: 5,
      message: 'Zip code must contain at least 5 characters'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Zip Code",
    type: "text",
    name: "zip"
  })))), /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "default",
    htmlType: "submit"
  }, "Search"))));
};
var _default = _form.default.create({
  name: 'FilterPharmacyForm'
})(FilterPharmacyForm);
exports.default = _default;